import {useState} from "react";
import api from "@/api/axios.js";

const ALLOWED_EXTENSIONS = [".png", ".jpg", ".jpeg", ".webp", ".psd", ".ai", ".pdf", ".tif", ".tiff"];

function isImageFile(filename)
{
	const ext = filename.toLowerCase().split(".").pop();
	return ALLOWED_EXTENSIONS.includes(`.${ext}`);
}

function getUploadFilename(file)
{
	const relativePath = typeof file?.webkitRelativePath === "string"
		? file.webkitRelativePath.trim()
		: "";

	if (relativePath)
		return relativePath;

	return file?.name || "file";
}

export function useUploadRefs(flyerId)
{
	const [isUploading, setIsUploading] = useState(false);
	const [error, setError] = useState(null);

	const uploadRefs = async (files, options = {}) =>
	{
		if (!flyerId)
			throw new Error("FlyerId non specificato");

		if (!files || files.length === 0)
			throw new Error("Nessun file selezionato");

		// Filtrare solo file immagine supportati
		const validFiles = files.filter(file => isImageFile(file.name));

		if (validFiles.length === 0)
			throw new Error("Nessun file immagine valido trovato. Formati supportati: PNG, JPG, JPEG, WebP, PSD, AI, PDF, TIF, TIFF");

		setIsUploading(true);
		setError(null);

		try
		{
			const formData = new FormData();
			validFiles.forEach(file =>
			{
				formData.append("refs", file, getUploadFilename(file));
			});

			const profileId = options?.webpProfileId || options?.profileId;
			if (profileId)
				formData.append("webpProfileId", profileId);

			const {data} = await api.post(`/api/flyers/${flyerId}/refs`, formData, {
				headers: {
					"Content-Type": "multipart/form-data"
				}
			});

			return data;
		}
		catch (err)
		{
			const errorMessage = err?.response?.data?.error || err.message || "Errore durante l'upload";
			setError(errorMessage);
			throw new Error(errorMessage);
		}
		finally
		{
			setIsUploading(false);
		}
	};

	return {uploadRefs, isUploading, error};
}
